// extracted by mini-css-extract-plugin
export default {"save":"select-owner-modal_save__vHusA","checkbox":"select-owner-modal_checkbox__PQYZO"};